import React from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';

interface OverpaymentConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  overpaymentAmount: number;
  onConfirm: (createCredit: boolean) => void;
  isLoading: boolean;
}

const OverpaymentConfirmModal: React.FC<OverpaymentConfirmModalProps> = ({
  open,
  onOpenChange,
  overpaymentAmount,
  onConfirm,
  isLoading,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-amber-500" />
            Overpayment Detected
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              The customer paid <span className="font-semibold">{formatCurrency(overpaymentAmount)}</span> more than the invoice amount.
            </p>
            <p>
              Would you like to create a credit for this customer that can be applied to future invoices?
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="outline"
            onClick={() => onConfirm(false)}
            disabled={isLoading}
          >
            No, Just Record Payment
          </Button>
          <Button
            onClick={() => onConfirm(true)}
            disabled={isLoading}
          >
            {isLoading ? 'Processing...' : 'Yes, Create Credit'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default OverpaymentConfirmModal;
